import { useState, useEffect } from 'react'
import downArrow from '../src/assets/down-arrow.svg'
import { Link, useLocation } from 'react-router-dom'

const AccordionItem = ({data}) => {
  const { children, name, isOpen } = data
  return (
    <>
      {children ? <svg className={`arrow_icon ${isOpen ? 'open': ''}`} fill='#1E293B' xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" width="512" height="298" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 512 298.04"><path fillRule="nonzero" d="M12.08 70.78c-16.17-16.24-16.09-42.54.15-58.7 16.25-16.17 42.54-16.09 58.71.15L256 197.76 441.06 12.23c16.17-16.24 42.46-16.32 58.71-.15 16.24 16.16 16.32 42.46.15 58.7L285.27 285.96c-16.24 16.17-42.54 16.09-58.7-.15L12.08 70.78z"/></svg> : null}
      {name}
    </>
  )
}

const Accordion = ({children, name, slug, open}) => {
    const [isOpen, setOpen] = useState(false)

    useEffect(() => {
      setOpen(open)
    }, [open])
  
    const { pathname } = useLocation()
    const isActiveSlug = pathname === '/' + slug
    return (
      <div className='accordion'>
        {
          !slug ? (
            <button className='accordion_title' onClick={() => setOpen(!isOpen)}>
              <AccordionItem data={{children, name, slug, isOpen}} />
            </button>
          ) : (
            <span className={`accordion_title ${isActiveSlug ? 'accordion_title_active' : ''}`}>
              <Link to={slug}>
                <AccordionItem data={{children, name, isOpen}} />
              </Link>
            </span>
          )
        }
        <div className={`accordion_content ${isOpen ? 'open': ''}`}>
          {children}
        </div>
      </div>
    )
  }

export default Accordion